@if (column(); as column) {
  @if (model(); as model) {
    @switch (column.key) {
      @case (getColumnKey('status')) {
        <app-warehouse-receipt-status [status]="model.status" />
      }

      @case (getColumnKey('productNames')) {
        @for (name of model.productNames; track name) {
          <div>{{ name }}</div>
        }
      }

      @case (getColumnKey('productSkus')) {
        {{ model.productSkus | joinStringArray }}
      }

      @default {
        <app-table-body-no-reference-cell [columnKey]="column.key" />
      }
    }
  }
}
